import * as pages from '@wr/ui-patterns';
import {
    Adyen,
    Optile,
    OptileSAQA,
    OptilePaymentProcessing,
    CybersourceWrapper,
    CybersourceFormWrapper,
    TrueLayerStatusWaiting,
    TrueLayerProviderSelection,
    ManualBankTransfer,
    PoliStatusWaiting,
    AdyenStatusWaiting,
    TabapayConfirmation,
    TabapayStatusWaiting,
    GoToMobile,
    CybersourceConfirmation,
    ZepzPayinStatusWaiting,
    ZepzPayin
} from './components/pages';
import Root from './components/Root';
import config from './config';

const {NotFound} = pages;

const getRoutes = () => {
    const routes = [{
        component: Root,
        routes: [
            {
                path: '/:language/payment-providers/cb/sessions/:sessionId',
                component: CybersourceWrapper,
                exact: true
            },
            {
                path: '/:language/payment-providers/cb/sessions/:sessionId/form',
                component: CybersourceFormWrapper,
                exact: true
            },
            {
                path: '/:language/payment-providers/cb/sessions/:sessionId/confirmation',
                component: CybersourceConfirmation,
                exact: true
            },
            {
                path: '/:language/payment-providers/opt/sessions/:sessionId',
                component: config.features.optileSAQA.enabled ? OptileSAQA : Optile,
                exact: true
            },
            // path still used
            {
                path: '/:language/payment-providers/opt-bank-payment-processing/sessions/:sessionId',
                component: OptilePaymentProcessing,
                exact: true,
                strict: true
            },
            // OPT-4 never released (this below is not working)
            {
                path: '/:language/payment-providers/opt/payment/sessions/:sessionId/authorise',
                component: OptilePaymentProcessing,
                exact: true,
                strict: true
            },
            {
                path: '/:language/payment-providers/tl/sessions',
                component: TrueLayerStatusWaiting,
                exact: true
            },
            {
                path: '/:language/payment-providers/mbt/sessions/:sessionId',
                component: ManualBankTransfer,
                exact: true
            },
            {
                path: '/:language/payment-providers/poli/sessions/:sessionId',
                component: PoliStatusWaiting,
                exact: true,
                strict: true
            },
            {
                path: '/:language/payment-providers/tp/sessions/:sessionId/confirmation',
                component: TabapayConfirmation,
                exact: true
            },
            {
                path: '/:language/payment-providers/tp/sessions/:paymentSessionId/status',
                component: TabapayStatusWaiting,
                exact: true
            },
            {
                path: '/:language/payment/status/:statusName/gotoapp',
                component: GoToMobile,
                exact: true
            },
            {
                path: '/:language/payment-providers/adyen/:adyenMethod(fpx)/sessions/:paymentSessionId/status',
                component: AdyenStatusWaiting,
                exact: true,
                strict: true
            },
            {
                path: '/:language/payment-providers/adyen/:adyenMethod(fpx)/sessions/:paymentSessionId',
                component: Adyen,
                exact: true
            }
        ]
    }];

    if (config.features.trueLayerIntegration.enabled) {
        routes[0].routes.push(
            {
                path: '/:language/payment-providers/tl/sessions/:sessionId',
                component: TrueLayerProviderSelection,
                exact: true,
                rootSectionClassName: 'true-layer-root-section'
            }
        );
    }

    if (config.features.zepzPayinIntegration.enabled) {
        const zepzRoutes = [
            {
                path: '/:language/payment-providers/zepz/sessions/:paymentSessionId',
                component: ZepzPayin,
                exact: true
            },
            {
                path: '/:language/payment-providers/zepz/sessions/:paymentSessionId/status',
                component: ZepzPayinStatusWaiting,
                exact: true,
                strict: true
            }
        ];

        routes[0].routes.push(...zepzRoutes);
    }

    routes[0].routes.push({
        path: '*',
        component: NotFound
    });

    return routes;
};

export default {
    getRoutes
};
